import { __assign, __awaiter, __generator } from "tslib";
import axios from 'axios';
import store from '@/store';
import router from '@/router';
// 基础 API 地址，从环境变量获取，默认使用该域名
export var BASE_URL = process.env.VUE_APP_API_BASE || 'http://live.taohuanuo.homes/api';
var instance = axios.create({
    baseURL: BASE_URL,
    timeout: 10000,
});
instance.interceptors.request.use(function (config) {
    var token = store.state.token || localStorage.getItem('token');
    if (token)
        config.headers.Authorization = "Bearer ".concat(token);
    return config;
}, function (error) { return Promise.reject(error); });
instance.interceptors.response.use(function (response) {
    var res = response.data;
    if (res.code !== 200) {
        if (res.code === 401) {
            store.commit('CLEAR_AUTH');
            router.push('/login');
            ElMessage.error('登录已过期，请重新登录');
        }
        else {
            ElMessage.error(res.msg || '操作失败');
        }
        // 不抛出异常，调用方可安全读取 res.code 判断
        return Promise.resolve(response);
    }
    return response;
}, function (error) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var message = '服务异常';
    if (error.response) {
        var status = error.response.status;
        switch (status) {
            case 401:
                message = '身份验证失败';
                store.commit('CLEAR_AUTH');
                router.push('/login');
                break;
            case 403:
                message = '没有操作权限';
                break;
            case 404:
                message = '资源不存在';
                break;
            case 500:
                message = '服务器错误';
                break;
            default:
                message = "\u8BF7\u6C42\u5931\u8D25 (".concat(status, ")");
        }
    }
    else if (error.code === 'ECONNABORTED') {
        message = '请求超时，请重试';
    }
    else if (error.message.includes('Network Error')) {
        message = '网络连接失败';
    }
    ElMessage.error(message);
    // 构造一个符合 ApiResponse 格式的错误对象，并正常返回（不 reject）
    var errorResponse = __assign(__assign({}, error.response), { data: {
            code: (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : -1,
            msg: message,
            data: null,
        }, status: (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.status) !== null && _d !== void 0 ? _d : 0, statusText: (_f = (_e = error.response) === null || _e === void 0 ? void 0 : _e.statusText) !== null && _f !== void 0 ? _f : '', headers: (_h = (_g = error.response) === null || _g === void 0 ? void 0 : _g.headers) !== null && _h !== void 0 ? _h : {}, config: error.config });
    return Promise.resolve(errorResponse);
});
// 通用 GET 请求
export var get = function (url, params, config) { return instance.get(url, __assign(__assign({}, config), { params: params })).then(function (res) { return res.data; }); };
// 通用 POST 请求
export var post = function (url, data, config) { return instance.post(url, data, config).then(function (res) { return res.data; }); };
// 获取完整资源 URL
export function getFullUrl(path) {
    if (!path)
        return '';
    if (path.startsWith('http') ||
        path.startsWith('data:') ||
        path.startsWith('blob:')) {
        return path;
    }
    return BASE_URL + path;
}
/**
 * 从 Content-Disposition 头中提取文件名
 */
function getFileNameFromContentDisposition(contentDisposition) {
    if (!contentDisposition)
        return undefined;
    var match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    return match ? match[1].replace(/['"]/g, '') : undefined;
}
/**
 * 从 URL 路径中提取文件名（最后一段）
 */
function getFileNameFromUrl(url) {
    var parts = url.split('/');
    return parts[parts.length - 1] || 'download';
}
export function downloadFile(url, defaultFileName) {
    return __awaiter(this, void 0, Promise, function () {
        var token, headers, response, fileName, contentDisposition, blob, blobUrl, link, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    token = localStorage.getItem('token') || store.state.token;
                    headers = {};
                    if (token) {
                        headers['Authorization'] = "Bearer ".concat(token);
                    }
                    return [4 /*yield*/, fetch(url, { headers: headers })];
                case 1:
                    response = _a.sent();
                    if (!response.ok)
                        throw new Error("HTTP error! status: ".concat(response.status));
                    fileName = defaultFileName;
                    if (!fileName) {
                        contentDisposition = response.headers.get('Content-Disposition');
                        fileName = getFileNameFromContentDisposition(contentDisposition);
                    }
                    if (!fileName) {
                        fileName = getFileNameFromUrl(url);
                    }
                    return [4 /*yield*/, response.blob()];
                case 2:
                    blob = _a.sent();
                    blobUrl = window.URL.createObjectURL(blob);
                    link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(blobUrl);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('下载失败:', error_1);
                    ElMessage.error('下载失败，请重试');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function downloadFileByPath(relativePath, fileName) {
    var fullUrl = "".concat(BASE_URL, "api/common/file/download?path=").concat(encodeURIComponent(relativePath));
    var link = document.createElement('a');
    link.href = fullUrl;
    if (fileName)
        link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
